var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 34.5,
    rx: 6,
    fill: "#219653"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2499 9.08578C14.1391 8.80327 15.0669 8.66101 15.9999 8.66411C19.8334 8.66411 22.4423 10.9558 23.9978 12.9761C24.777 13.9899 25.1666 14.495 25.1666 15.9974C25.1666 17.5008 24.777 18.0059 23.9978 19.0188C22.4423 21.0391 19.8334 23.3308 15.9999 23.3308C12.1664 23.3308 9.55759 21.0391 8.002 19.0188C7.22284 18.0068 6.83325 17.4999 6.83325 15.9974C6.83325 14.4941 7.22284 13.989 8.002 12.9761C8.4773 12.3554 9.00643 11.7778 9.58325 11.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16C18.75 16.7293 18.4603 17.4288 17.9445 17.9445C17.4288 18.4603 16.7293 18.75 16 18.75C15.2707 18.75 14.5712 18.4603 14.0555 17.9445C13.5397 17.4288 13.25 16.7293 13.25 16C13.25 15.2707 13.5397 14.5712 14.0555 14.0555C14.5712 13.5397 15.2707 13.25 16 13.25C16.7293 13.25 17.4288 13.5397 17.9445 14.0555C18.4603 14.5712 18.75 15.2707 18.75 16Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeView);
export default __webpack_public_path__ + "static/media/EyeView.9496bd29b1831b07702aee67db21867c.svg";
export { ForwardRef as ReactComponent };